<ng-content></ng-content>
@if (entity && items) {
  <nk-card @fadeAnimation [andClass]="noBorder ? 'mb-2 border-0' : 'mb-2'">
    <nk-card-content andClass="p-3">
      <div class="row">
        @for (item of items; track item; let first = $first) {
          <div class="col-12 {{ item.andClass }} mb-2 mb-sm-0">
            <p class="d-sm-none text-muted mb-0">
              {{ item.label | translate }}
              @if (item.headerTooltipMessage) {
                <nk-help-popover class="ms-2" [popoverTemplate]="item.headerTooltipMessage"></nk-help-popover>
              }
              :
            </p>
            @if (detailsComponent && first && collapsibleDetails) {
              <nk-caret-expander
                class="me-2"
                [topOffest]="0"
                [isExpanded]="!isCollapsed"
                (click)="isCollapsed = !isCollapsed"></nk-caret-expander>
            }
            <div class="d-inline-flex">
              <ng-template
                nkCardListItem
                [nkCardListItemComponent]="item.component"
                [entity]="entity"
                [entityProp]="item.prop">
              </ng-template>
            </div>
          </div>
        }
      </div>
      @if (detailsComponent) {
        <div [collapse]="collapsibleDetails && isCollapsed">
          @if (!collapsibleDetails || !isCollapsed) {
            <div class="well well-lg card card-inset card-block card-header mt-2 mb-0">
              <ng-template nkCardListItemDetails [nkCardListItemDetailsComponent]="detailsComponent" [entity]="entity">
              </ng-template>
            </div>
          }
        </div>
      }
    </nk-card-content>
  </nk-card>
}
